// Static agent data scraped from Bayleys profile
// Source: https://www.bayleys.co.nz/agents/kaid-maycock-9357

export const BAYLEYS_LOGO = 'https://customer-assets.emergentagent.com/job_c6237d2d-e310-469a-b99f-bb09818662c4/artifacts/88edcyju_ATB-Logo.svg';

export const AGENT = {
  firstName: 'Kaid',
  lastName: 'Maycock',
  fullName: 'Kaid Maycock',
  title: 'Residential Sales and Marketing',
  tagline: 'Hibiscus Coast Residential Specialist',
  photo: '/images/kaid-maycock.jpg',
  phone: '+64 21 285 1884',
  phoneHref: 'tel:+64212851884',
  email: 'kaid.maycock@bayleys.co.nz',
  emailHref: 'mailto:kaid.maycock@bayleys.co.nz',
  rating: 5.0,
  reviewCount: 18,
  reviewUrl: 'https://www.ratemyagent.co.nz/real-estate-agent/kaid-maycock-as133/sales/overview',
  careerVolume: '$150M+',
  yearsOnCoast: '10+',
  office: {
    name: 'Milldale',
    legal: 'Mackys Real Estate Ltd, Bayleys',
    licence: 'Licensed under the REA Act 2008',
    address: '5/1 Henry Tayler Rise, Milldale',
    phone: '+64 9 426 5911',
    phoneHref: 'tel:+6494265911',
    email: 'milldale@bayleys.co.nz',
    emailHref: 'mailto:milldale@bayleys.co.nz',
    mapUrl: 'https://maps.google.co.nz/?q=5/1+Henry+Tayler+Rise,+Milldale+NZ',
  },
  socials: {
    facebook: 'https://www.facebook.com/kaidmaycockrealestate/',
    instagram: 'https://www.instagram.com/kaidmaycock/',
    linkedin: 'https://www.linkedin.com/in/kaid-maycock-16361826a',
  },
  areas: [
    'Gulf Harbour',
    'Milldale',
    'Millwater',
    'Orewa',
    'Red Beach',
    'Silverdale',
    'Stanmore Bay',
  ],
  bio: [
    "Kaid specialises in residential sales across the Hibiscus Coast — a place he's proudly called home and been an active part of for over a decade. Backed by a career sales volume exceeding $150 million and numerous industry awards, Kaid has a reliable and strong track record. His local knowledge on the coast, a sharp eye for detail, and a genuine 100% commitment to quality underpins his process and approach to selling.",
    "With previous experience in both residential and commercial development land sales, he has assisted a wide variety of clients with many types of negotiations. Kaid provides trusted advice and consistently puts clients' needs first to secure favourable outcomes.",
    "Buying or selling a home is one of life's biggest decisions, and Kaid strives to make that process as positive and stress-free as possible. Kaid is highly process-driven, with a disciplined approach. From strategy and marketing execution through to negotiation, each step is carefully planned, reviewed, and refined to maximise value for his clients. No stone is left unturned, ensuring homes are positioned correctly, marketed effectively, and negotiated with precision.",
  ],
};

export const TESTIMONIALS = [
  {
    quote: "I was impressed with Kaid on first meeting with him to discuss the sale of my house. He had a good knowledge of the market and was totally correct in his estimation of my property's value. His marketing and strategy information was well informed and useful. Kaid worked very hard during the negotiation process and a successful outcome was achieved thanks to his commitment.",
    author: 'Steven Laker',
    date: 'May 2026',
  },
  {
    quote: "Kaid has been extremely helpful in our house buying journey. From the start he has been transparent and honest, and has helped make what was once quite a stressful, confusing process into an easier, more enjoyable one. His communication is excellent and he answered every question we had with confidence, kindness and urgency.",
    author: 'Kieran & Madi',
    date: 'April 2026',
  },
  {
    quote: "Kaid was such a delight to work with — so helpful, professional, and always very calm, warm, and personable. Many property salespeople can be very pushy, which can be off-putting, but Kaid isn't like that at all. He always followed up and answered any questions promptly, without ever pressuring us. Highly recommend him!",
    author: 'Nina & Mark',
    date: 'November 2025',
  },
  {
    quote: "We were very impressed with Kaid's friendly approach, clarity, communication, professionalism and willingness to work with the vendor and us, as first home buyers, to get a fair deal done. We wouldn't hesitate to recommend him to anyone selling their home.",
    author: 'Tyler & Maria',
    date: 'May 2026',
  },
];
